<template>
		<el-dialog :title="form.emailId ? '录入邮件/微信日志' : '编辑邮件/微信日志'" :visible.sync="visible" :before-close="beforeClose" width="70%">
				<el-form :model="form" inline style="margin-top: 30px;">
					<el-row>
						<el-form-item label="邮件/微信主题">
							<el-input v-model="form.title" type="text" autocomplete="off"
													class="text-width"></el-input>
							<span style="color:red;margin-left:20px;">若为续约邮件，则填写“续约邮件”</span>
						</el-form-item>
						<el-form-item label="工单编号">
							<el-input v-model="form.sheetCode" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="发送/接收时间">
							<el-input v-model="form.sendTime" type="text" autocomplete="off"
													class="text-width"></el-input>
							<!-- <el-date-picker
								v-model="form.sendTime"
								type="datetime"
								placeholder="选择日期时间"
								value-format="yyyy-MM-dd HH:mm:ss"
								format="yyyy-MM-dd HH:mm:ss"
								:shortcuts="shortcuts">
								</el-date-picker> -->
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="发件人">
							<el-input v-model="form.fromEmail" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
						<el-form-item label="收件人">
							<el-input v-model="form.toEmail" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>     
					<el-row>
						<el-form-item label="邮件/微信内容">
							<el-input v-model="form.content" size="medium" :rows="8" type="textarea"
								 autocomplete="off" placeholder="请输入邮件/微信内容" style="width:1000px"
								></el-input>
						</el-form-item> 
					</el-row>  
					
					<el-row>
						<my-upload-file-form-item v-model="sampleArray" label="附件" :limit="10" />
					</el-row>  

					<el-row>
						<span style="color:red;">*注意*</span>
					</el-row>   
					<el-row>
						<span style="color:red;margin-left:20px;">1、工单编号若存在 “测试” 或 “打错” 关键词，将不统计到报告中</span>
					</el-row>     
					<el-row>
						<span style="color:red;margin-left:20px;">2、若为续约订单，工单编号必须带“续约”关键词</span>
					</el-row>    
					<el-row>
						<span style="color:red;margin-left:20px;">3、若为微信沟通，发件人填写为“微信”</span>
					</el-row>               
				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="beforeClose">取消</el-button>
						<el-button type="primary" @click="onConfirm">保存</el-button>
				</div>
		</el-dialog>

</template>

<script>
import {SaveEmailLog} from "@/api/bd";
import {getToken} from "@/utils/auth";
import {mapGetters} from "vuex";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getFileUrl} from "@/api/file";

export default {
		name: "EditAccountDialog",
		components: {MyUploadFileFormItem},
		// computed: {
		// 		...mapGetters(['mediumList', 'mediaList',])
		// },
		props: ['visible','dateArray','searchkey', 'currentItem'],
		watch: {
				async visible(newValue) {
						if (newValue) {
								if (this.currentItem?.emailId) {
										this.form = this.currentItem;
										this.sampleArray = this.form.sample?.split(';').filter(item => !!item).map(fileName => {
																return {name: fileName, url: getFileUrl({name: fileName})};
															}) ?? []
								}
						}else{
							this.sampleArray=[];
						}
				}
		},
		data() {
				return {
					form:{},
					sampleArray:[],
					shortcuts: [{
						text: '今天',
						value: new Date(),
						}, {
						text: '昨天',
						value: () => {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							return date
						},
						}, {
						text: '一周前',
						value: () => {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							return date
						},
						}],
				};
		},
		methods: {
				async onConfirm() {
						const {emailId, title,content,fromEmail,toEmail,sendTime,sheetCode} = this.form;
						const [sDate, eDate] = this.dateArray;

						if (!sheetCode?.trim()) {
							this.$message.warning('请输入工单编号')
							return;
						}

						if (!fromEmail?.trim()) {
							this.$message.warning('请输入完整的发件邮箱')
							return;
						}

                        await SaveEmailLog({userId: getToken(), emailId: emailId ?? '',title,content,fromEmail,toEmail
							,sendTime,sheetCode,sample:this.sampleArray?.map(item => item.name).join(';') ?? ''});
						// this.form = {accountName:'', account : '', bank:'',};
						this.form={};

						this.beforeClose();
						 await this.$store.dispatch("bd/emailLogList", {
                            sDate,
                            eDate,
                            key:this.searchkey
                        })
				},
				beforeClose() {
						this.$emit('update:visible', false);
				}
		}
}
</script>

<style scoped>

</style>